/** 매출 > 배송운임 엔티티 */
export default class InvoiceDeliveryCharge {
    /** 임시 값 */
    id = 0;
    orderHub = '';
    unit = 0;
    count = 0;
    supplyPrice = 0;
    vatIncluded = 0;
    dataCheck = '';
    constructor(_data = {}) {
        Object.assign(this, _data);
    }
}
